import FileSecurityPage from './FileSecurityPage.page';

export default FileSecurityPage;
